<template>
  <v-stepper-items>
    <v-stepper-content step="1">
      <!-- Informações Gerais -->
      <InformacoesGerais :form="form" />
    </v-stepper-content>

    <v-stepper-content step="2">
      <!-- Restrições -->
      <Restricao :item="form" :regioesRepresentantes="regioesRepresentantes" />
    </v-stepper-content>

    <v-stepper-content step="3">
      <!-- Segmentos -->
      <Segmentos :form="form" :dimensoes="dimensoes" />
    </v-stepper-content>

    <v-stepper-content step="4">
      <!-- Produtos -->
      <MixProdutos :form="form" />
    </v-stepper-content>

    <v-stepper-content step="5">
      <!-- Comissões -->
      <RangesComissao :form="form" />
    </v-stepper-content>
  </v-stepper-items>
</template>

<script>
import InformacoesGerais from "./InformacoesGerais.vue";
import MixProdutos from "./MixProdutos.vue";
import RangesComissao from "./RangesComissao.vue";
import Restricao from "./Restricao.vue";
import Segmentos from "./Segmentos.vue";

export default {
  name: "StepsFormComissao",
  props: ["form", "step", "dimensoes", "regioesRepresentantes"],
  components: {
    InformacoesGerais,
    RangesComissao,
    MixProdutos,
    Segmentos,
    Restricao,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
